module.exports = __webpack_public_path__ + "img/page4-bg.94b7e54c.png";